// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sirin+Stencil&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --theme-color: #6060FF;
    --hover-light-color: rgba(0, 0, 0, 0.05);
    --hover-color: rgba(0, 0, 0, 0.1);
    --primary-color: #6060FF;
    --secondaryA-color: #8040FF;
    --secondaryB-color: #4080FF;
    --black: #0F0F28;
    --grey: #56606D;
    --silver: #484960;
    --success: #34A853;
    --navbar-height: 60px
}

/*@font-face {*/
/*  font-family: 'SirinStencil-Regular';*/
/*  src: url('../assets/fonts/SirinStencil-Regular.ttf') format('truetype');*/
/*  font-weight: normal;*/
/*  font-style: normal;*/
/*}*/


* {
    font-family: sans-serif;
}

html, body {
    max-width: 100%;
    overflow-x: hidden;
}

p {
    color: var(--black);
    font-size: 15px;
}

button,
input[type="button"],
input[type="submit"],
input[type="reset"] {
    /* Removes the border */
    border: none;

    /* Resets the background to none */
    background: none;


    /* Resets the padding */
    padding: 0;

    /* Resets the margin */
    margin: 0;

    /* Sets the font to inherit from the parent */
    font-family: inherit;
    font-size: inherit;
    color: inherit;

    /* Removes the default button appearance in WebKit browsers */
    -webkit-appearance: none;

    /* Removes the default button appearance in Firefox */
    -moz-appearance: none;

    /* Cursor to denote clickable */
    cursor: pointer;
}

.global__main___uD0zC {
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
}


.global__screenContainer___Gr5I7 {
    display: flex;
    padding: 52px;
    padding-top: 15vh;
    flex-direction: column;
    overflow-x: hidden;
    width: 860px;
    min-height: 80vh;
}

.global__vaultMain___Mvm2P {
    width: 80vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 260px;
    padding-bottom: 8vh;
    min-height: 90vh;
    padding-top: var(--navbar-height);
}

.global__vaultScreenContainer___MHZCO {
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    padding-left: 52px;
    padding-top: 20px;
    width: 100%;
}

.global__box____5Iy9 {
    width: 520px;
    box-shadow: 2px 6px 20px 10px rgba(0, 0, 0, 0.15);
    padding: 86px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 34px;
    min-height: 50vh;
}

@media screen and (max-width: 1100px) {
    .global__box____5Iy9 {
        width: 90vw;
    }
}

.global__centerScreen___cBSyi {
    align-self: center;
    align-items: center;
}

.global__blackColor___g9vAy {
    color: var(--black)
}

.global__greyColor___cXwOa {
    color: var(--grey)
}

.global__silverColor___S_2ss {
    color: var(--silver)
}

.global__primaryColor___P6QRi {
    color: var(--primary-color)
}

@media screen and (max-width: 1100px) {
    .global__screenContainer___Gr5I7 {
        width: 90vw;
    }
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;IACtB,wCAAwC;IACxC,iCAAiC;IACjC,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA,eAAe;AACf,yCAAyC;AACzC,6EAA6E;AAC7E,yBAAyB;AACzB,wBAAwB;AACxB,IAAI;;;AAGJ;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;;IAII,uBAAuB;IACvB,YAAY;;IAEZ,kCAAkC;IAClC,gBAAgB;;;IAGhB,uBAAuB;IACvB,UAAU;;IAEV,sBAAsB;IACtB,SAAS;;IAET,6CAA6C;IAC7C,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;;IAEd,6DAA6D;IAC7D,wBAAwB;;IAExB,qDAAqD;IACrD,qBAAqB;;IAErB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iDAAiD;IACjD,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Sirin+Stencil&display=swap');\n\n:root {\n    --theme-color: #6060FF;\n    --hover-light-color: rgba(0, 0, 0, 0.05);\n    --hover-color: rgba(0, 0, 0, 0.1);\n    --primary-color: #6060FF;\n    --secondaryA-color: #8040FF;\n    --secondaryB-color: #4080FF;\n    --black: #0F0F28;\n    --grey: #56606D;\n    --silver: #484960;\n    --success: #34A853;\n    --navbar-height: 60px\n}\n\n/*@font-face {*/\n/*  font-family: 'SirinStencil-Regular';*/\n/*  src: url('../assets/fonts/SirinStencil-Regular.ttf') format('truetype');*/\n/*  font-weight: normal;*/\n/*  font-style: normal;*/\n/*}*/\n\n\n* {\n    font-family: sans-serif;\n}\n\nhtml, body {\n    max-width: 100%;\n    overflow-x: hidden;\n}\n\np {\n    color: var(--black);\n    font-size: 15px;\n}\n\nbutton,\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n    /* Removes the border */\n    border: none;\n\n    /* Resets the background to none */\n    background: none;\n\n\n    /* Resets the padding */\n    padding: 0;\n\n    /* Resets the margin */\n    margin: 0;\n\n    /* Sets the font to inherit from the parent */\n    font-family: inherit;\n    font-size: inherit;\n    color: inherit;\n\n    /* Removes the default button appearance in WebKit browsers */\n    -webkit-appearance: none;\n\n    /* Removes the default button appearance in Firefox */\n    -moz-appearance: none;\n\n    /* Cursor to denote clickable */\n    cursor: pointer;\n}\n\n.main {\n    width: 100vw;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n\n.screenContainer {\n    display: flex;\n    padding: 52px;\n    padding-top: 15vh;\n    flex-direction: column;\n    overflow-x: hidden;\n    width: 860px;\n    min-height: 80vh;\n}\n\n.vaultMain {\n    width: 80vw;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-left: 260px;\n    padding-bottom: 8vh;\n    min-height: 90vh;\n    padding-top: var(--navbar-height);\n}\n\n.vaultScreenContainer {\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n    padding-left: 52px;\n    padding-top: 20px;\n    width: 100%;\n}\n\n.box {\n    width: 520px;\n    box-shadow: 2px 6px 20px 10px rgba(0, 0, 0, 0.15);\n    padding: 86px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-radius: 34px;\n    min-height: 50vh;\n}\n\n@media screen and (max-width: 1100px) {\n    .box {\n        width: 90vw;\n    }\n}\n\n.centerScreen {\n    align-self: center;\n    align-items: center;\n}\n\n.blackColor {\n    color: var(--black)\n}\n\n.greyColor {\n    color: var(--grey)\n}\n\n.silverColor {\n    color: var(--silver)\n}\n\n.primaryColor {\n    color: var(--primary-color)\n}\n\n@media screen and (max-width: 1100px) {\n    .screenContainer {\n        width: 90vw;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `global__main___uD0zC`,
	"screenContainer": `global__screenContainer___Gr5I7`,
	"vaultMain": `global__vaultMain___Mvm2P`,
	"vaultScreenContainer": `global__vaultScreenContainer___MHZCO`,
	"box": `global__box____5Iy9`,
	"centerScreen": `global__centerScreen___cBSyi`,
	"blackColor": `global__blackColor___g9vAy`,
	"greyColor": `global__greyColor___cXwOa`,
	"silverColor": `global__silverColor___S_2ss`,
	"primaryColor": `global__primaryColor___P6QRi`
};
export default ___CSS_LOADER_EXPORT___;
